import React from "react"
import { createUseStyles } from "react-jss"
import Image from "next/legacy/image"
import { Container, Row, Col } from "../components/layout/grid"
import txtBcg from "../assets/images/path-copy-2.webp"

import colors from "../styles/colors"
import { fontSize } from "../styles/fonts-constants"

const useStyles = createUseStyles({
  driverShowCase: {
    flexGrow: 1,
    paddingTop: 40,
    paddingBottom: 40,
  },
  title: {
    fontFamily: "var(--font-montserrat), sans-serif",
    color: colors.blue1,
    fontSize: fontSize.extraLarge,
    textAlign: "center",
  },
  cntTitle: {
    fontFamily: "var(--font-montserrat), sans-serif",
    lineHeight: 1.42,
    color: colors.blue5,
    fontSize: fontSize.normal,
    marginTop: 35,
    marginBottom: 15,
  },
  cntTitleWithBackground: {
    extend: "cntTitle",
    display: "inline-block",
    background: `url(${txtBcg}) no-repeat`,
    padding: "0 15px",
    marginLeft: "-15px",
    backgroundSize: "100% 100%",
  },
  txtCnt: {
    fontFamily: "'Roboto', sans-serif",
    lineHeight: 1.42,
    color: colors.blue5,
    fontSize: fontSize.medium,
  },
  mobileImg: {
    maxWidth: 445,
    marginTop: 20,
  },
  "@media all and (max-width: 768px)": {
    mobileImg: {
      display: "none",
    },
    title: {
      textAlign: "left",
    },
  },
  subtitle: {
    textAlign: "center",
    fontSize: fontSize.small,
    marginTop: 24,
    marginBottom: 80,
  },
})

const DriverShowCase = ({ showcaseData }) => {
  const classes = useStyles()

  return (
    <div className={classes.driverShowCase}>
      <Container>
        <Row className="align-items-center">
          <Col sm={12}>
            <h2 className={classes.title}>{showcaseData.title}</h2>
            <h3 className={classes.subtitle}>{showcaseData.subTitle}</h3>
          </Col>
          <Col md={6}>
            {showcaseData.content.map((dataUnit, index) => {
              return (
                <div key={index}>
                  <h3
                    className={`${classes.cntTitle} ${
                      dataUnit.backgroundDecoration
                        ? classes.cntTitleWithBackground
                        : ``
                    }`}
                  >
                    {dataUnit.heading}
                  </h3>
                  <p className={classes.txtCnt}>{dataUnit.description}</p>
                </div>
              )
            })}
          </Col>
          <Col md={6} className="text-center">
            <div>
              <Image
                src={showcaseData.image}
                width={445}
                height={764}
                alt="Mobile Screenshot"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default DriverShowCase
